export default "__VITE_ASSET__355910bd__"